/* línkè · 对话线 API (2026-05-26)
   每条对话强绑定一个角色卡（character_id）。换角色 = 开新对话。 */

const BASE = '/api/conversations';

async function jsonOrThrow(res) {
  const text = await res.text();
  let data;
  try { data = JSON.parse(text); } catch { throw new Error('non-JSON: ' + text.slice(0, 120)); }
  if (!res.ok) {
    const err = new Error(data.error || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

/** 列出所有对话（含归档），后端按 archived asc, updated_at desc 排好。 */
export async function fetchConversations() {
  const res = await fetch(BASE, { credentials: 'include' });
  const data = await jsonOrThrow(res);
  return data.conversations || [];
}

/** 新建。前端生成 id 保证幂等。character_id 可空（"自由对话"）。 */
export async function createConversation({ id, name, character_id }) {
  if (!id || !name) throw new Error('id and name required');
  const res = await fetch(BASE, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, name, character_id }),
  });
  return jsonOrThrow(res);
}

export async function renameConversation(id, name) {
  const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
  return jsonOrThrow(res);
}

export async function setConversationArchived(id, archived) {
  const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ archived: !!archived }),
  });
  return jsonOrThrow(res);
}

/** 硬删除：同时删除该对话下所有消息。 */
export async function deleteConversation(id) {
  const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  return jsonOrThrow(res);
}
